// Auth

import AuthLayout from 'layouts/auth/Layout.svelte';



import AuthLogin from 'views/auth/Login.svelte';

import AuthLogout from 'views/auth/Logout.svelte';

import AuthCodeSendNew from 'views/auth/code/SendNew.svelte';
import AuthCodeSeeNew from 'views/auth/code/SeeNew.svelte';



// My

import MyLayout from 'layouts/my/Layout.svelte';


import MyTeamsIndex from 'views/my/teams/Index.svelte';
import MyTeamIndex from 'views/my/team/Index.svelte';

// import MyTeamPlayers from 'views/my/team/Players.svelte';
// import MyTeamParents from 'views/my/team/Players.svelte';
// import MyTeamJerseys from 'views/my/team/Players.svelte';
// import MyTeamTracksuits from 'views/my/team/Tracksuits.svelte';


import MyProgramsIndex from 'views/my/programs/Index.svelte';
import MyProgramIndex from 'views/my/program/Index.svelte';


import MyResourcesIndex from 'views/my/resources/Index.svelte';
import MyResourceArticle from 'views/my/resources/Article.svelte';
import MyResourceVideo from 'views/my/resources/Video.svelte';
import MyResourcePDF from 'views/my/resources/PDF.svelte';


import MyFAQIndex from 'views/my/faq/Index.svelte';


import MyFreeAgentsIndex from 'views/my/free-agents/Index.svelte';

import MyIRPSIndex from 'views/my/irps/Index.svelte';


import MySchedulesIndex from 'views/my/schedules/Index.svelte';
import MySchedule from 'views/my/schedules/Schedule.svelte';


import MyCoachesGuideIndex from 'views/my/coaches-guide/Index.svelte';

import MyCodeOfConductIndex from 'views/my/code-of-conduct/Index.svelte';



import MyHotelsIndex from 'views/my/hotels/Index.svelte';

import MyGoalieClinicsIndex from 'views/my/goalie-clinics/Index.svelte';

import MyRulesAndFormatIndex from 'views/my/rules-and-format/Index.svelte';


import MySettingsIndex from 'views/my/settings/Index.svelte';


import MyContactIndex from 'views/my/contact/Index.svelte';


import MyCovidIndex from 'views/my/covid/Index.svelte';


// Errors

import ErrorsLayout from 'layouts/errors/Layout.svelte';


import ErrorsNotFound from 'views/errors/NotFound.svelte';





const routes = [
	// Auth
	{
		name: 'login',
		component: AuthLogin,
		layout: AuthLayout,
	},
	{
		name: 'logout',
		component: AuthLogout,
	},
	{
		name: 'code/send-new',
		component: AuthCodeSendNew,
		layout: AuthLayout,
	},
	{
		name: 'code/new/:token',
		component: AuthCodeSeeNew,
		layout: AuthLayout,
	},
	{
		name: 'contact',
		component: MyContactIndex,
		layout: AuthLayout,
	},
	// My
	{
		name: 'my',
		component: MyLayout,
		onlyIf: {
			// ...
		},
		nestedRoutes: [
			{
				name: 'teams',
				component: MyTeamsIndex,
			},
			{
				name: 'team/:team_instance_id',
				component: MyTeamIndex,
				// redirectTo: 'players',
				// nestedRoutes: [
				// 	{
				// 		name: 'players',
				// 		component: MyTeamPlayers,
				// 	},
				// 	{
				// 		name: 'parents',
				// 		component: '',
				// 	},
				// 	{
				// 		name: 'jerseys',
				// 		component: '',
				// 	},
				// 	{
				// 		name: 'tracksuits',
				// 		component: '',
				// 	},
				// ],
			},
			{
				name: 'programs',
				component: MyProgramsIndex,
			},
			{
				name: 'program/:program_instance_id',
				component: MyProgramIndex,
			},
			{
				name: 'resources',
				component: MyResourcesIndex,
			},
			{
				name: 'resource/article/:slug', // slug instead ... ?
				component: MyResourceArticle,
			},
			{
				name: 'resource/video/:slug', // slug instead ... ?
				component: MyResourceVideo,
			},
			{
				name: 'resource/pdf/:slug',
				component: MyResourcePDF,
			},
			// {
			// 	name: 'schedules',
			// 	component: MySchedulesIndex,
			// },
			// {
			// 	name: 'schedule/:schedule_id',
			// 	component: MySchedule,
			// },
			{
				name: 'hotels',
				component: MyHotelsIndex,
			},
			// {
			// 	name: 'settings',
			// 	component: MySettingsIndex,
			// },
			{
				name: 'faq',
				component: MyFAQIndex,
			},
			{
				name: 'free-agents',
				component: MyFreeAgentsIndex,
			},
			{
				name: 'goalie-clinics',
				component: MyGoalieClinicsIndex,
			},
			{
				name: 'rules-and-format',
				component: MyRulesAndFormatIndex,
			},
			{
				name: 'coaches-guide',
				component: MyCoachesGuideIndex,
			},
			{
				name: 'code-of-conduct',
				component: MyCodeOfConductIndex,
			},
			{
				name: 'irps',
				component: MyIRPSIndex,
			},
			{	
				name: 'contact',
				component: MyContactIndex,	
			},
			{
				name: 'covid',
				component: MyCovidIndex,
			},
		],
	},
	// Errors
	{
		name: '404',
		path: '404',
		component: ErrorsNotFound,
		layout: ErrorsLayout,
	}
]




export { routes };



